import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { supabase } from '../../services/Supabase';
import { toast } from 'react-toastify';

/* React Icons */
import { FaSpinner } from 'react-icons/fa';
import CompanyLogo from "../../assets/img/company-logo.webp";
import Loader from '../../components/Loader';

import commonFunction from '../../utils/CommonFunction';

const ForgotPassword = () => {
    const [loadingButton, setLoadingButton] = useState(false);
    const { parseError } = commonFunction();

    /* FORMS: Use States / Setters */
    const [formData, setFormData] = useState({
        email: "",
    });
    const { email } = formData;
    
    const navigate = useNavigate();
    const { user, userMetaData, loading } = useAuth();

    /* Use Effects */
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.hash.substring(1));
        const errorObject = {};
        for (const [key, value] of urlParams.entries()) {
            errorObject[key] = value;
        }
        if (errorObject.error && errorObject.error_code && errorObject.error_description) {
            toast.error(errorObject.error_description);
        }
        if (errorObject.message) {
            toast.success(errorObject.message);
        }
    }, []);

    // Redirect if already logged in
    useEffect(() => {
        if (user && userMetaData) {
            const redirectURL = userMetaData.user_role === 'administrator' ? '/admin/dashboard' : '/dashboard';
            navigate(redirectURL);
        }
    }, [user, userMetaData, navigate]);


    function onChange(e){
        setFormData((prevState) => ({
            ...prevState,
            [e.target.id]: e.target.value,
        }));
    }
    async function onSubmit(e){
        e.preventDefault();
        setLoadingButton(true);

        const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
            redirectTo: `${window.location.origin}/update-password`,
        });

        if (error) {
            const errorObject = parseError(error.message);
            toast.error(errorObject.code);
            setLoadingButton(false);
        } else {
            setLoadingButton(false);
            console.log(data)
            toast.success("Password recovery link sent! Kindly verify the link by checking your inbox.");
        }
    }
    
    if (loading) {
        return <Loader />;
    }

    return (
        <>
            <section className="main-form-section">
                <div className="container">
                    <div className="banner-wrapper">
                        <div className="form-section-wrapper">
                            <form onSubmit={onSubmit}>
                                <div className="form-header"><img src={CompanyLogo} alt="Company Logo" /></div>
                                <div className="login-heading">
                                    <h2>FORGOT PASSWORD</h2>
                                </div>
                                {/* Email */}
                                <div className="form-wrapper">
                                    <label htmlFor="email">Email Address *</label>
                                    <div className="form-group">
                                        <input type="email" className="form-input" id="email" name="email" placeholder="Email Address" value={email} onChange={onChange} required />
                                    </div>
                                </div>
                                <div className="form-group">
                                    {loadingButton ? 
                                        (<button className="submit-button w-100" type="button"><FaSpinner className="spinner" disabled /> Sending, Please wait... </button>) : 
                                        (<button className="submit-button w-100" id="submit-button" type="submit"> Send Password Recovery</button>)
                                    }
                                </div>
                                <div className="sign-in-text">
                                    <ul>
                                        <li>Don't have an account? <Link to="/sign-up">Sign Up here</Link></li>
                                    </ul>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ForgotPassword;